import GlobalStyles from "@/app/globalStyles";
import * as S from "@admin/root/render/styles";
import PageLayout from "@template/layout/PageLayout";
import { Default as NavSectionComponentDef } from "@template/blocks/NavigationSection/NavigationSection.stories.ts";
import { Default as FooterSectionComponentDef } from "@template/blocks/FooterSection/FooterSection.stories.ts";
import { usePuck } from "@measured/puck";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
// @ts-ignore
import puckStylesheet from "@measured/puck/dist/index.css";
import { StoreThemeProvider } from "@template/providers/StoreThemeProvider.tsx";
import useScaleContext from "@template/layout/AdminEditor/Editor/ScaleProvider.tsx";

const FrameContent = ({ children, rootProps }) => {
  const permissions = useTypedSelector((state) => state.admin.permissions);
  const subTab = useTypedSelector((state) => state.admin.sidebar_tab_sub);

  const {
    appState: {
      data: {
        root: { props: puckRootProps },
      },
    },
  } = usePuck();
  const { scale } = useScaleContext();

  const usedRoot = rootProps || puckRootProps;

  const altLayout = usedRoot?.settings?.alt_layout;
  const navLinks = usedRoot?.settings?.nav_links;
  const userControlLinks = usedRoot?.settings?.userControlLinks;

  return (
    <>
      <GlobalStyles />
      <S.Wrapper
        style={
          {
            "--scale": (1 / scale).toFixed(2),
          } as any
        }
      >
        {subTab ? (
          <S.SecondaryPageLayout>
            <StoreThemeProvider>
              <S.Container $hasEditPermission={permissions.edit}>
                {children}
              </S.Container>
            </StoreThemeProvider>
          </S.SecondaryPageLayout>
        ) : (
          <StoreThemeProvider>
            <PageLayout
              navigation={{
                ...NavSectionComponentDef.args,
                altStyling: altLayout || false,
                nav_links: navLinks || false,
                userControlLinks: userControlLinks || "Cart/Basket Only",
              }}
              footer={FooterSectionComponentDef.args as any}
            >
              <S.Container $hasEditPermission={permissions.edit}>
                {children}
              </S.Container>
            </PageLayout>
          </StoreThemeProvider>
        )}
      </S.Wrapper>
    </>
  );
};

export default FrameContent;
